(function () {
	'use strict';

	angular
		.module('in-out-rm', [
			'ngSanitize',
			{
				name: 'infinite-scroll',
				files: [staticContentCdnUrl+"./libs/ng-infinite-scroll.min.js"]
			}
		]);
})();
